import React from 'react';

export const LongArrowRight: React.FC<React.HTMLAttributes<SVGElement>> = (
  props
) => (
  <svg viewBox="0 0 24 24" {...props}>
    <path
      d="M2.781 11.194h16.545l-2.741-2.815a.825.825 0 010-1.14.764.764 0 011.1 0l4.082 4.194a.826.826 0 010 1.142l-4.082 4.194a.764.764 0 01-1.1 0 .825.825 0 010-1.14l2.741-2.816H2.781a.807.807 0 010-1.613z"
      fill="currentColor"
    />
  </svg>
);
